module.exports = __webpack_public_path__ + "img/open.7da41017.gif";